import React from 'react';
import { getShortAddressStr } from '../../../utils';
import {
  useAppKit,
  useAppKitAccount,
  useDisconnect,
} from '@reown/appkit/react';

const WalletConnect = (props) => {
  const { className = '', variant = '' } = props; // Destructure props correctly
  const { handleButton } = props;
  const { open } = useAppKit();
  const { address, isConnected } = useAppKitAccount();
  const { disconnect } = useDisconnect();

  const handleWalletConnect = () => {
    if (handleButton) handleButton(true);
    open();
  };

  return (
    <>
      {isConnected ? (
        <button
          onClick={() => {
            disconnect();
          }}
          type='button'
          className={`${
            className ? className : 'btn mb-0 me-0 me-md-3'
          } btn-info`}
        >
          {`Disconnect ${getShortAddressStr(address)}`}
        </button>
      ) : (
        <button
          onClick={handleWalletConnect}
          type='button'
          className={` ${variant ? variant : 'bg-gradient-primary'} ${
            className ? className : 'btn bg-gradient-primary mb-0 me-0 me-md-3'
          }`}
        >
          Wallet Connect
        </button>
      )}
    </>
  );
};

export default WalletConnect;
